
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Database } from "lucide-react";
import { shouldShowMockDataForUser, getEnvironment } from "@/utils/environment";
import { useIsDeveloper } from "@/hooks/useIsDeveloper";

interface MockDataButtonProps {
  onSuccess: () => void;
}

export const MockDataButton = ({ onSuccess }: MockDataButtonProps) => {
  const { data: isDeveloper = false } = useIsDeveloper();
  const currentEnv = getEnvironment();

  const handleClick = async () => {
    if (!shouldShowMockDataForUser(isDeveloper)) {
      toast.info("Mock data is only available for platform developers.");
      return;
    }
    
    toast.info("Mock data feature has been deprecated. Please create real client data.");
  };

  // Show the button if:
  // 1. In development environment (always)
  // 2. In other environments but user is a developer
  const shouldShowButton = currentEnv === 'development' || isDeveloper;

  if (!shouldShowButton) {
    return null;
  }

  return (
    <Button 
      onClick={handleClick} 
      variant="outline"
      className="flex items-center gap-2"
    >
      <Database className="h-4 w-4" />
      {currentEnv === 'development' ? 'Add Mock Data (Dev Only)' : 'Add Mock Data (Developer)'}
    </Button>
  );
};
